<template>
    <b-card class="shadow">
        <div class="row">
            <div class="col-12">
                <div
                    class="d-flex align-items-center justify-content-between mb-4"
                >
                    <h5 class="mb-0 text-gray-800">
                        {{ $t("Todos os registros de Equipe SUAS") }}
                    </h5>
                    <b-button-group>
                        <b-button
                            variant="outline-dark"
                            :class="viewFilterReport === true ? 'active' : ''"
                            @click="viewFilters"
                        >
                            <i class="fas fa-filter"></i>
                            {{ $t("Filtros") }}
                        </b-button>
                        <b-button variant="outline-dark" @click="print()">
                            <i class="fas fa-print"></i>
                        </b-button>
                        <b-button
                            variant="outline-dark"
                            @click="exportar()"
                            :title="$t('Exportar')"
                            v-b-tooltip.hover
                        >
                            <i class="fas fa-file-excel"></i>
                        </b-button>
                    </b-button-group>
                </div>
            </div>

            <div class="col-12" v-if="viewFilterReport">
                <!-- Filtros -->
                <form @submit.prevent="getAnalytics" ref="addItem">
                    <div class="row">
                        <form-calendar
                            v-model="data_inicio"
                            grid="3"
                            label="Data inicial"
                            :max-date="dataNow"
                        />

                        <form-calendar
                            v-model="data_fim"
                            grid="3"
                            label="Data final"
                            :required="verificaDataInicial"
                            :min-date="data_inicio"
                            :max-date="dataNow"
                        />

                        <form-select
                            grid="6"
                            v-model="filtroRoles"
                            :itens="roles"
                            placeholder="Selecione"
                            label="Função na Unidade/Sistema"
                            :multiple="true"
                        />

                        <form-select
                            grid="6"
                            v-model="filtroEscolaridades"
                            :itens="$root.arrays.tiposEscolaridadeTecnicos"
                            placeholder="Selecione"
                            label="Escolaridade(s)"
                            multiple
                        />
                        <form-select
                            grid="6"
                            v-model="filtroCargaHoraria"
                            :itens="$root.arrays.cargaHorariaTecnicos"
                            placeholder="Selecione"
                            label="Carga Horária"
                            multiple
                        />

                        <form-select
                            grid="6"
                            v-model="filtroRegimeTrabalho"
                            :itens="$root.arrays.regimeTrabalhoTecnicos"
                            placeholder="Selecione"
                            label="Regime de Trabalho"
                            multiple
                        />

                        <form-select
                            v-model="filtroStatus"
                            grid="6"
                            label="Status"
                            :itens="status"
                            :loading="loadingStatus"
                            :disabled="loadingStatus"
                            multiple
                        />

                        <form-select
                            v-model="filtroUnidades"
                            label="Unidade(s)"
                            grid="12"
                            :itens="unidades"
                            :disabled="desabledSearchUnidade"
                            :loading="loadingSearchUnidade"
                            multiple
                        />

                        <div class="col-md-12">
                            <label><b>Pesquisar</b></label>
                            <div class="input-group">
                                <b-input
                                    placeholder="No campo acima você pode pesquisar por: Nome, E-mail, Data de Nascimento ou Cargo"
                                    class="form-control search-input"
                                    type="text"
                                    v-model="search"
                                    aria-describedby="input-search"
                                    @keydown.enter.prevent="getAnalytics"
                                />
                            </div>
                            <p class="small text-muted">
                                No campo acima você pode pesquisar por: Nome,
                                E-mail, Data de Nascimento ou Cargo.
                            </p>
                        </div>
                        <form-toggle
                            v-model="showfiltroIdade"
                            grid="12"
                            label="Filtrar por intervalo de idade?"
                        />

                        <div class="col-md-12 mt-3 mb-5" v-if="showfiltroIdade">
                            <label><b>Idade</b></label>
                            <vue-slider
                                v-model="filtroIdade"
                                :min="min"
                                :max="max"
                                :tooltip="'always'"
                                :tooltip-placement="'bottom'"
                            ></vue-slider>
                        </div>
                    </div>
                    <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
                        <div class="col-auto px-2 text-right">
                            <button
                                class="btn btn-default"
                                @click.prevent="
                                    limparFiltros(), (viewFilterReport = false)
                                "
                            >
                                <i class="fas fa-times"></i>
                            </button>

                            <button
                                type="button"
                                class="btn btn-secondary"
                                @click.prevent="limparFiltros()"
                            >
                                {{ $t("Limpar Filtros") }}
                            </button>

                            <button
                                class="btn btn-success btn-submit"
                                data-style="zoom-in"
                                type="submit"
                            >
                                <i class="fas fa-chart-bar"></i>
                                {{ $t("Gerar Relatório") }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <loading-report
                :loading="isLoadingMsg"
                mensagem="Por favor aguarde estamos realizando sua solicitação..."
                icone="fa-smile-wink"
            ></loading-report>

            <div class="col-md-12">
                <loading-animation
                    :active.sync="loading"
                    :is-full-page="false"
                    :opacity="1"
                    color="#5895FF"
                />

                <print-content>
                        <template v-slot:datas>
                        <p
                            class="d-flex align-items-center justify-content-between mb-4"
                        >
                            <span
                                >Período selecionado:
                                <b>{{ datas.start }} - {{ datas.end }}</b>
                                <b-link
                                    href="#"
                                    @click.prevent="void 0"
                                    class="mb-2"
                                    variant="info"
                                    v-b-popover.hover.top="
                                        'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                                    "
                                >
                                    <i class="fas fa-info-circle"></i> </b-link
                            ></span>

                            <span v-if="pagination.total"
                                >Total de Registros <b>{{ pagination.total }}</b
                                >, total por página
                                <b>{{ pagination.perPage }}</b></span
                            >
                        </p>
                    </template>

                    <b-table
                        :fields="[
                            {
                                key: 'nome',
                                label: $t('Detalhes'),
                            },
                            {
                                key: 'unidade',
                                label: $t('Unidade(s)'),
                            },
                            {
                                key: 'role',
                                label: $t('Role'),
                            },
                            {
                                key: 'datas',
                                label: $t('Datas'),
                            },
                            {
                                key: 'status',
                                label: $t('Status'),
                            },
                        ]"
                        :items="itensList"
                        responsive="sm"
                        striped
                        hover
                        stacked="xs"
                        show-empty
                        small
                        outlined
                        table-class="mb-3"
                    >
                        <template v-slot:cell(nome)="data">
                            <strong
                                v-html="
                                    $options.filters.highlight(
                                        data.item.nome,
                                        search
                                    )
                                "
                            >
                            </strong>
                            <p
                                class="text-muted small pb-0 mb-0"
                                v-if="data.item.data_nascimento"
                            >
                                {{ data.item.idade_extenso }}
                            </p>
                            <!-- <span class="small d-block" v-if="data.item.cpf">
                CPF:
                <strong
                  v-html="$options.filters.highlight(data.item.cpf, search)"
                >
                </strong>
              </span> -->
                            <span
                                class="small d-block"
                                v-html="
                                    $options.filters.highlight(
                                        data.item.email,
                                        search
                                    )
                                "
                            >
                            </span>
                            <span
                                class="small d-block"
                                v-html="
                                    $options.filters.highlight(
                                        data.item.telefone,
                                        search
                                    )
                                "
                            >
                            </span>
                            <span class="small d-block" v-if="data.item.sexo">
                                Sexo:
                                <b>{{
                                    data.item.sexo == 1
                                        ? "Masculino"
                                        : "Feminino"
                                }}</b>
                            </span>
                            <span
                                class="small d-block"
                                v-if="data.item.profissao"
                            >
                                Cargo:
                                <strong
                                    v-html="
                                        $options.filters.highlight(
                                            data.item.profissao,
                                            search
                                        )
                                    "
                                >
                                </strong>
                            </span>
                            <span
                                class="small d-block"
                                v-if="data.item.escolaridade"
                            >
                                Escolaridade:
                                <b>{{
                                    $options.filters.formatEscolaridade(
                                        data.item.escolaridade
                                    )
                                }}</b>
                            </span>
                        </template>
                        <template v-slot:cell(unidade)="data">
                            <div
                                class="small"
                                v-if="data.item.transformed.unidades.length > 0"
                            >
                                <div
                                    v-for="item in data.item.transformed
                                        .unidades"
                                    :key="item.id"
                                    class="d-block pb-1 border-bottom-1"
                                >
                                    <div>
                                        <b>
                                            <span
                                                v-if="
                                                    item.unidade.id ==
                                                    data.item.unidade.id
                                                "
                                                title="Unidade Padrão"
                                            >
                                                <i
                                                    class="fa fa-check"
                                                    aria-hidden="true"
                                                ></i>
                                            </span>
                                            <span v-else> - </span>
                                            {{ item.unidade.nome }}
                                        </b>
                                        <br />
                                        <span
                                            class="small d-block pl-4"
                                            v-if="item.regime_trabalho"
                                        >
                                            Regime de Trabalho:
                                            <b>{{
                                                $options.filters.formatRegimeTrabalhoTecnicos(
                                                    item.regime_trabalho
                                                )
                                            }}</b>
                                        </span>
                                        <span
                                            class="small d-block pl-4"
                                            v-if="item.carga_horaria"
                                        >
                                            Carga Horária:
                                            <b>{{
                                                $options.filters.formatCargaHoraria(
                                                    item.carga_horaria
                                                )
                                            }}</b>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <span
                                    class="small d-block"
                                    v-if="data.item.unidade"
                                >
                                    <b>{{ data.item.unidade.name }}</b>
                                </span>
                                <span
                                    class="small d-block"
                                    v-if="data.item.regime_trabalho"
                                >
                                    Regime de Trabalho:
                                    <b>{{
                                        $options.filters.formatRegimeTrabalhoTecnicos(
                                            data.item.regime_trabalho
                                        )
                                    }}</b>
                                </span>
                                <span
                                    class="small d-block"
                                    v-if="data.item.carga_horaria"
                                >
                                    Carga Horária:
                                    <b>{{
                                        $options.filters.formatCargaHoraria(
                                            data.item.carga_horaria
                                        )
                                    }}</b>
                                </span>
                            </div>
                        </template>
                        <template v-slot:cell(role)="data">
                            {{ data.item.role.value }}
                        </template>
                        <template v-slot:cell(datas)="data">
                            <span
                                class="text-muted small d-block"
                                v-if="data.item.data_nascimento"
                            >
                                Nascimento: {{ data.item.data_nascimento }}
                            </span>
                            <span
                                class="text-muted small d-block"
                                v-if="data.item.data_admissao"
                            >
                                Admissão:
                                {{
                                    $options.filters.formatDate(
                                        data.item.data_admissao
                                    )
                                }}
                            </span>
                            <span class="text-muted small d-block">
                                Criado em: {{ data.item.cadastro }}
                            </span>
                        </template>
                        <template v-slot:cell(status)="data">
                            <span v-html="data.item.status_nome"></span>
                            <span
                                v-if="
                                    data.item.status_nome_sem_formatacao ==
                                    'INATIVO'
                                "
                            >
                                <b-popover
                                    v-if="data.item.historicos"
                                    :target="`popover-target-${data.item.historicos.id}`"
                                    triggers="hover"
                                    placement="top"
                                >
                                    <b>Data: </b
                                    >{{ data.item.historicos.data_atualizacao
                                    }}<br />
                                    <b>Motivo: </b>{{ data.item.historicos.motivo?.descricao || 'N/A' }}<br />
                                    <b>Observação: </b
                                    >{{ data.item.historicos.observacoes }}
                                </b-popover>

                                <i
                                    v-if="data.item.historicos"
                                    class="fas text-danger fa-info-circle"
                                    :id="`popover-target-${data.item.historicos.id}`"
                                ></i>
                            </span>
                        </template>

                        <template v-slot:empty="scope" v-if="!loading">
                            <div class="text-center my-5">
                                <img
                                    :alt="$t('No results')"
                                    class="mb-5"
                                    src="/img/icons/robot.svg"
                                    style="max-height: 165px"
                                />
                                <h3 class="bold">
                                    {{ $t("No records found") }}
                                </h3>
                            </div>
                        </template>
                    </b-table>
                </print-content>

                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="form-group d-inline-flex mb-0">
                            <select
                                class="form-control"
                                style="width: 70px"
                                v-model="perPage"
                                v-on:change="getAnalytics"
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        <div class="d-inline-flex ml-2">
                            <b-pagination
                                :per-page="perPage"
                                :total-rows="pagination.total"
                                @change="changePage"
                                v-model="page"
                            />
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                        <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }} {{ $t("of") }}
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                        </div>
                    </div>
                </div>
                <div class="box-btn-print no-print">
                    <b-button
                        v-if="!loading"
                        :title="$t('Visualizar e Imprimir')"
                        class="py-2"
                        size="sm"
                        type="button"
                        v-b-tooltip.hover
                        variant="primary"
                        @click="print()"
                    >
                        <i class="fas fa-print"></i>
                    </b-button>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
export default {
    name: "HomeReportTecnicos",
    data() {
        return {
            loading: true,
            loadingSearchUnidade: true,
            desabledSearchUnidade: true,
            loadingSearchTecnico: true,
            loadingSearchTecnicoAcomp: true,
            range: null,
            itensList: [],
            unidades: [],
            tecnicos: [],
            tecnicosAcomp: [],
            page: 1,
            search: "",
            perPage: 10,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            filtros: {
                unidade: null,
            },
            isLoadingMsg: false,
            filter: false,
            user_id: null,
            tecnico_id: null,
            unidade_id: null,
            role: null,
            loadingStatus: false,
            loadingTipos: false,
            tipos: [],
            status: [],
            datas: [],
            showfiltroIdade: false,
            idades: null,
            filtroIdade: [],
            filtroUnidades: [],
            filtroDatas: [],
            filtroStatus: [],
            filtroRoles: [],
            filtroEscolaridades: [],
            filtroCargaHoraria: [],
            filtroRegimeTrabalho: [],
            roles: [],
        };
    },
    created() {
        this.min = 18;
        this.max = 65;
        this.enableCross = false;
    },

    mounted() {
        this.getAnalytics();
        this.getStatus();
        this.getUnidades();
        this.getRoles();
    },
    watch: {
        showfiltroIdade(val) {
            this.filtroIdade = val ? [18, 65] : [];
        },
    },
    methods: {
        filterData(value) {
            return this.$options.filters.formatDateHora(value);
        },
        updateAnalytics(range) {
            if (this.range !== range) {
                this.range = range;
                this.getAnalytics();
            }
        },
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getAnalytics();
            }
        },
        async getAnalytics() {
            this.isLoadingMsg = true;
            this.loading = true;

            this.filtroDatas = [];
            if (this.data_inicio) {
                this.filtroDatas.push(
                    this.$options.filters.formatDateYMD(this.data_inicio)
                );
            }
            if (this.data_fim) {
                this.filtroDatas.push(
                    this.$options.filters.formatDateYMD(this.data_fim)
                );
            }

            if (this.filtroIdade && this.filtroIdade.length > 0) {
                this.idades =
                    "Usuários com Idade entre: " +
                    this.filtroIdade[0] +
                    " ano(s) e " +
                    this.filtroIdade[1] +
                    " ano(s)";
            }

            await axios
                .get("api/dashboard/report/tecnicos/home", {
                    params: {
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                        range: this.range,
                        filtroIdade: this.filtroIdade,
                        filtroUnidades: this.filtroUnidades,
                        filtroDatas: this.filtroDatas,
                        filtroStatus: this.filtroStatus,
                        filtroRoles: this.filtroRoles,
                        filtroEscolaridades: this.filtroEscolaridades,
                        filtroCargaHoraria: this.filtroCargaHoraria,
                        filtroRegimeTrabalho: this.filtroRegimeTrabalho,
                    },
                })
                .then((response) => {
                    this.loading = false;

                    this.user_id = this.$store.state.user.id;
                    this.tecnico_id = this.$store.state.user.tecnico.id;
                    this.unidade_id = this.$store.state.unidade;
                    this.role = this.$store.state.user.role;

                    this.datas = response.data.datas;
                    this.itensList = response.data.dados.original.data;
                    this.pagination = response.data.dados.original.pagination;
                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getAnalytics();
                    } else {
                        this.isLoadingMsg = false;
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.isLoadingMsg = false;
                    this.loading = false;
                });
        },
        exportar() {
            this.isLoadingMsg = true;
            this.loading = true;
            swal.fire({
                title: "Aguarde! O Arquivo está sendo gerado.",
                text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
                imageUrl: `${window.urlbase}img/load.gif`,
                showConfirmButton: false,
            });
            axios
                .get("api/dashboard/report/tecnicos/home", {
                    params: {
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                        range: this.range,
                        filtroIdade: this.filtroIdade,
                        filtroUnidades: this.filtroUnidades,
                        filtroDatas: this.filtroDatas,
                        filtroStatus: this.filtroStatus,
                        filtroRoles: this.filtroRoles,
                        filtroEscolaridades: this.filtroEscolaridades,
                        filtroCargaHoraria: this.filtroCargaHoraria,
                        filtroRegimeTrabalho: this.filtroRegimeTrabalho,
                        export: "ok",
                    },
                })
                .then((response) => {
                    this.isLoadingMsg = false;
                    this.loading = false;

                    swal.fire({
                        title: "Arquivo Pronto para Download!",
                        html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
                        icon: "success",
                        showConfirmButton: false,
                    });
                })
                .finally(() => {
                    (this.isLoadingMsg = false), (this.loading = false);
                });
        },
        getUnidades() {
            this.loadingSearchUnidade = true;
            this.desabledSearchUnidade = true;
            axios
                .get(`api/dashboard/unidades/get/externas`)
                .then((response) => {
                    this.unidades = response.data;
                })
                .finally(() => {
                    this.loadingSearchUnidade = false;
                    this.desabledSearchUnidade = false;
                });
        },
        getStatus() {
            this.loadingStatus = true;
            axios
                .get(`api/dashboard/report/status/tecnicos`)
                .then((response) => {
                    this.status = response.data;
                })
                .finally(() => {
                    this.loadingStatus = false;
                });
        },
        getTipos() {
            //   axios.get(`api/dashboard/tipos/tecnicos`).then((response) => {
            //     this.tipos = response.data;
            //   });
        },
        getTecnicos() {
            this.tecnicos = [];
            this.loadingSearchTecnico = true;
            axios
                .get(`api/dashboard/atendimento/tecnicos/get`, {
                    params: {
                        unidades: this.filtroUnidades,
                    },
                })
                .then((response) => {
                    this.tecnicos = response.data;
                })
                .finally(() => (this.loadingSearchTecnico = false));
        },
        getTecnicosAcomp() {
            this.tecnicosAcomp = [];
            this.loadingSearchTecnicoAcomp = true;
            axios
                .get(`api/dashboard/atendimento/tecnicos/get`, {
                    params: {
                        unidades: this.filtroUnidadesAcomp,
                    },
                })
                .then((response) => {
                    this.tecnicosAcomp = response.data;
                })
                .finally(() => (this.loadingSearchTecnicoAcomp = false));
        },
        limparFiltros() {
            //   this.filtros = {};
            this.search = "";
            this.data_inicio = "";
            this.data_fim = "";
            this.filtros.data_inicial = "";
            this.filtros.data_final = "";

            this.filtroUnidades = [];
            this.filtroDatas = [];
            this.filtroStatus = [];
            this.filtroRoles = [];

            this.filtroEscolaridades = [];
            this.filtroCargaHoraria = [];
            this.filtroRegimeTrabalho = [];
            this.filtroIdade = [];
            this.showfiltroIdade = false;
            this.idades = null;

            this.range = null;

            this.getAnalytics();
        },
        async getRoles() {
            // Get all settings values
            await axios
                .get("api/dashboard/report/tecnicos/users/roles")
                .then((response) => {
                    if (response.data.data) {
                        this.roles = response.data.data.map((elem) => ({
                            id: elem.id,
                            value: elem.name,
                        }));
                    }

                    // this.roles = response.data.data;
                    this.loading = false;
                });
        },
    },
};
</script>
